import { ChallengeRules } from '../types';

/**
 * Points PREVIEW for the stay so far. The official value comes from the server
 * at check-out. Same rule: proportional to the minimum stay, rounded up,
 * multiplying before dividing to avoid float errors.
 */
export function calcPoints(stayMinutes: number, rules: ChallengeRules): number {
  const { minStayMinutes, maxPoints } = rules;
  if (!minStayMinutes) return maxPoints;
  const stay = Math.min(Math.max(Math.floor(stayMinutes), 0), minStayMinutes);
  return Math.floor((stay * maxPoints + minStayMinutes - 1) / minStayMinutes);
}
